
const laoLeadTimeFilters = {
    importOrderOriginCountryList: { // Origin Country
        type: "text",
        name: "origin_country",
        stringToArray: true,
        data: null,
        region: 'lao',
        helperText: "helperText"
    },
    importOrderDestinationCountryList: { // Destination Country
        type: "text",
        name: "destination_country",
        stringToArray: true,
        data: null,
        region: 'lao',
        helperText: "helperText"
    },
    importShipmentModeList: { // Shipment Mode
        type: "checkbox",
        name: "shipment_mode",
        data: [
            { name: "maritime_m", value: "M", checked: false },
            { name: "land_t", value: "T", checked: false },
            { name: "air_a", value: "A", checked: false },
        ]
    },
    processTypeList: { // Process Type
        type: "checkbox",
        name: "process_type",
        data: [
            { name: "intercompany_ic", value: "IC", checked: false },
            { name: "external_vendor_ev", value: "EV", checked: false },
            { name: "direct_shipment_ds", value: "DS", checked: false },
        ]
    },
    vendorNumberList: { // Vendor Number
        type: "text",
        name: "vendor_number",
        stringToArray: true,
        data: null,
        region: 'lao',
        helperText: "helperText"
    },
    vendorNameWithSeparator: { // Vendor Name
        type: "text",
        name: "vendor_name",
        stringToArray: false,
        stringValue: true, // for chips UI 
        separator: /;/,
        data: null,
        region: 'lao',
        helperText: "helperTextWithSeparator"
    },
    customerCodeList: { // Customer Code / Plant
        type: "text",
        name: "customer_code",
        stringToArray: true,
        data: null,
        region: 'lao',
        helperText: "helperText"
    },
    customerNameWithSeparator: { // Customer Name
        type: "text",
        name: "customer_name",
        stringToArray: false,
        stringValue: true, // for chips UI
        separator: /;/,
        data: null,
        region: 'lao',
        helperText: "helperTextWithSeparator"
    },
    internationalShipperWithSeparator: { // International Shipper
        type: "text",
        name: "international_shipper",
        stringToArray: false,
        stringValue: true, // for chips UI
        separator: /;/,
        data: null,
        region: 'lao',
        helperText: "helperTextWithSeparator"
    },
    shipmentNumList: { // Shipment Number
        type: "text",
        name: "shipment_num",
        stringToArray: true,
        data: null,
        region: 'lao',
        helperText: "helperText"
    },
    containerIdList: { // Container ID
        type: "text",
        name: "container_id",
        stringToArray: true,
        data: null,
        region: 'lao',
        helperText: "helperText"
    },
    incotermList: { // Incoterm
        type: "text",
        name: "incoterm",
        stringToArray: true,
        data: null,
        region: 'lao',
        helperText: "helperText"
    },
    leadTimeEtdRange: { // KC ETD
        type: "date",
        name: "leadtime_shipment_etd_date",
        shortName: 'KC ETD',
        data: null
    },
    leadTimeEtaRange: { // KC ETA
        type: "date",
        name: "leadtime_shipment_eta_date",
        shortName: 'KC ETA',
        data: null
    },
    leadTimeIDDateRange: { // ID Date (International Declaration Date)
        type: "date",
        name: "leadtime_shipment_id_date",
        shortName: 'ID Date',
        data: null
    },
    leadTimeGRDateRange: { // GR Date (Goods Received Date)
        type: "date",
        name: "gr_date",
        shortName: 'GR Date',
        data: null
    },
    poCreationDateRange: { // PO Creation Date
        type: "date",
        name: "po_creation_date",
        shortName: 'PO Creation Date',
        data: null
    }
}

export default laoLeadTimeFilters;